module.exports = __webpack_public_path__ + "assets/img/leaf-attack.0d4dab8c.png";